import { render, staticRenderFns } from "./profile-two-user.vue?vue&type=template&id=a3361700&"
import script from "./profile-two-user.vue?vue&type=script&lang=js&"
export * from "./profile-two-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3361700')) {
      api.createRecord('a3361700', component.options)
    } else {
      api.reload('a3361700', component.options)
    }
    module.hot.accept("./profile-two-user.vue?vue&type=template&id=a3361700&", function () {
      api.rerender('a3361700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/profile-two-user.vue"
export default component.exports